import { useState, useCallback } from "react";
import { getAxios } from "../utils/axios";
const endpoint = "/inventory/folder_aliases";
export const useInventoryFolderAliases = () => {
    const [aliases, setAliases] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchAll = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await getAxios().get(endpoint);
            setAliases(res.data);
        }
        catch (err) {
            setError(err.message || "Failed to fetch folder aliases.");
        }
        finally {
            setLoading(false);
        }
    }, []);
    const create = async (payload) => {
        const res = await getAxios().post(endpoint, payload);
        await fetchAll();
        return res.data;
    };
    const update = async (uuid, payload) => {
        const res = await getAxios().put(`${endpoint}/${uuid}`, payload);
        await fetchAll();
        return res.data;
    };
    const patch = async (uuid, payload) => {
        const res = await getAxios().patch(`${endpoint}/${uuid}`, payload);
        await fetchAll();
        return res.data;
    };
    const remove = async (uuid) => {
        const res = await getAxios().delete(`${endpoint}/${uuid}`);
        await fetchAll();
        return res.data;
    };
    return { aliases, loading, error, fetchAll, create, update, patch, remove };
};
